module.exports = __webpack_public_path__ + "img/grondeigendom.8ca79bf0.png";